export const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI || 'http://localhost:4000/graphql';
export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL || 'http://localhost:4000/upload';

// Derives the static uploads folder path (e.g. replaces /upload with /uploads)
export const UPLOAD_BASE_URL = UPLOAD_URL.replace(/\/upload$/, '/uploads');
